import React from "react";
import { FiClipboard, FiFileText } from "react-icons/fi";
import { HomeOverviewCard } from "./HomeOverviewCard";
import taskRaisedIllustration from "../../img/task-raised-illustration.png";

export function HomeTasksRaised({ count = 0 }) {
  return (
    <HomeOverviewCard
      count={count}
      countLabel="Tasks Raised"
      description="View all tasks that you have created for others."
      Icon={FiClipboard}
      illustration={taskRaisedIllustration}
      title="Tasks Raised by Me"
      to="/tasks/reports/raised-by-me"
      tone="blue"
      VisualIcon={FiFileText}
    />
  );
}
